export default __webpack_public_path__ + "static/media/AGC_2022_R2_QP_Class_2.a3694633.pdf";